import React from 'react'

import PropTypes from 'prop-types'

import {
  EDITABLEELEMENT_VARIANT_DANGER,
  EDITABLEELEMENT_VARIANT_DEFAULT
} from './EditableElement.constants'
import { EditableElementContainer } from './EditableElement.styles'

const fromClipboard = event => {
  const clipboard = event.clipboardData ||
    window.clipboardData || { getData: () => '' }

  return clipboard.getData('text')
}

const stripHTML = s => s.replace(/(<[^>]>+)/, '')

const handleMaxLength = (s, n) => (n > 0 ? s.substring(0, n) : s)

export const EditableElement = ({
  value,
  placeholder,
  onChange,
  className,
  'data-mu-test': dataAttributeTest,
  name,
  maxLength,
  disabled,
  variant,
  multiline
}) => {
  const handleBlur = ({ target: { innerText } }) => {
    //  console.log('### handleBlur', innerText)
    onChange(handleMaxLength(innerText, maxLength))
  }

  const handleInput = ({ target: { innerText } }) => {
    //  console.log('### handleInput', innerText)
    //  onChange()
    //  onChange(handleMaxLength(innerText, maxLength))
  }

  const handlePaste = e => {
    e.preventDefault()
    const txt = fromClipboard(e)

    onChange(handleMaxLength(stripHTML(txt), maxLength))
  }

  const handleKeyDown = e => {
    if (e.key === 'Enter' && !multiline) {
      e.preventDefault()

      e.target.blur()
    }
  }

  return (
    <EditableElementContainer
      className={className}
      data-mu-test={dataAttributeTest}
      data-name={name}
      contentEditable={!disabled}
      suppressContentEditableWarning
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      onPaste={handlePaste}
      onInput={handleInput}
      placeholder={placeholder}
      variant={variant}
      disabled={disabled}
      multiline={multiline}
    >
      {value}
    </EditableElementContainer>
  )
}

EditableElement.defaultProps = {
  placeholder: 'empty',
  disabled: false,
  variant: EDITABLEELEMENT_VARIANT_DEFAULT,
  multiline: false
}

EditableElement.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  'data-mu-test': PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf([
    EDITABLEELEMENT_VARIANT_DEFAULT,
    EDITABLEELEMENT_VARIANT_DANGER
  ]),
  multiline: PropTypes.bool
}
